import { useCallback } from 'react';
import { getDatePickerDateType } from '../../date-picker';
import type { CalendarDateType } from '../types';

type P = {
  current: CalendarDateType;
  value: Date;
};

export const useGetWeekSelectionModeValues = () =>
  useCallback(({ current, value }: P) => {
    const base = getDatePickerDateType(value);
    const start = base.startOf('week');
    const end = base.endOf('week');

    return {
      isInWeek: !current.isBefore(start, 'day') && !current.isAfter(end, 'day'),
    };
  }, []);
